import React from "react"

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const FeatureFlagContext = React.createContext()

export const FeatureFlagProvider = FeatureFlagContext.Provider
export const FeatureFlagConsumer = FeatureFlagContext.Consumer

export default FeatureFlagContext
